<template>
  <div class="novel-detail" :style="`${novel.cover ? `background-image: url(${novel.cover})`: ''}`">
    <div class="novel-detail-wrap">
      <h3 class="novel-title">{{ novel.title }}</h3>
      <div class="author-info">
        <img v-if="novel.avatar" :src="novel.avatar" alt="" class="author-avatar">
        <p class="author-name">{{ novel.author }}</p>

      </div>
      <div v-if="novel.tags && novel.tags.length" class="novel-tags">
          <Tag v-for="(tag) in novel.tags" :key="tag.id">{{tag.name}}</Tag>
      </div>
      <template v-if="chapterList && chapterList.length">
        <TitleBar title="Chapter" :needMore="false" />
        <div class="novel-chapter">
          <div class="novel-chapter-scroll">
            <p
              v-for="(item) in chapterList"
              :key="item.id"
              :class="['novel-chapter-item', activeId === item.id ? 'active' : '']"
              @click="changeChapter(item)"
            >
              <img
                v-if="!item.is_unlock"
                src="@/assets/images/icon/lock-black.png"
                alt="" class="icon"
              >
              <span>{{item.title}}</span>
            </p>
          </div>
        </div>
      </template>
      <template v-if="novel.recommends && novel.recommends.length">
        <TitleBar title="Similar Comic" :needMore="false" />
        <div class="recommend-list">
          <div
            v-for="(item) in novel.recommends"
            :key="item.id"
            class="recommend-item"
            @click="goRecommend(item.id)"
          >
            <div class="image-wrap">
              <img :src="item.cover" alt="">
            </div>
            <div class="recommend-info">
              <p class="novel-title">{{ item.title }}</p>
              <p v-if="item.summary" class="novel-intro">{{ item.summary }}</p>
            </div>
          </div>
        </div>

      </template>

    </div>
    <div class="novel-operation">
      <div @click="handleFavorite" class="operation-button favorite">
        <i :class="['op-icon', isFavorite ? 'on' : 'off']"></i>
        Favorite
      </div>
      <div @click="readNow" class="operation-button read-now">
        <i class="op-icon"></i>
        Read Now
      </div>
    </div>
    <UnlockPopup :visible.sync="unlockPopupVisible" :info="priceInfo" @success="unlockSuccess"/>
  </div>
</template>

<script>
import {
  getNovelDetail, addFavorite, deleteFavorite, getNovelChapters,
} from '@/api';
import { debounce } from '@/utils';
import Tag from '@/components/Tag.vue';
import TitleBar from '@/components/TitleBar.vue';
import UnlockPopup from '@/components/UnlockPopup';

//
export default {
  components: { Tag, TitleBar, UnlockPopup },
  data() {
    return {
      id: '',
      novel: {},
      chapterList: [],
      activeId: '',
      isFavorite: false,
      unlockPopupVisible: false,
      priceInfo: {},
    };
  },
  watch: {
    '$route': {
      handler() {
        this.init();
      },
    },
  },
  created() {
    this.init();
    this.handleFavorite = debounce(this.handleFavorite, 1000);
    this.goRecommend = debounce(this.goRecommend, 1000);
  },
  methods: {
    init() {
      const { params: { id } } = this.$route || {};
      if (!id) return;
      this.id = id;
      this.getNovelInfo(id);
      this.getChapterList(id);
    },
    async getNovelInfo(id) {
      const res = await getNovelDetail(id);
      if (res.code !== 0) return;
      this.novel = res.data || {};
      this.isFavorite = Boolean(this.novel.is_collected);
      this.$nextTick(() => {
        document.documentElement.scrollTop = 0;
      });
    },
    async getChapterList(id) {
      const res = await getNovelChapters(id);
      if (res.code !== 0) return;
      this.chapterList = (res.data || []).sort((a, b) => a.idx - b.idx);
      const firstChapter = this.chapterList[0];
      this.activeId = firstChapter.is_unlock ? firstChapter.id : '';
    },
    async handleFavorite() {
      const { isFavorite } = this;
      const api = isFavorite ? deleteFavorite : addFavorite;
      const res = await api(this.id);
      if (res.code !== 0) {
        this.$toast.error(res.message);
        return;
      }
      this.$toast(isFavorite ? 'Favorite Deleted' : 'Favorite Added');
      this.isFavorite = !isFavorite;
    },
    changeChapter(item) {
      if (!(item.is_unlock || item.is_vipunlock)) {
        this.unlockChapter(item);
        return;
      }
      this.activeId = item.id;
    },
    unlockChapter(item) { // 解锁下一章
      const ids = [];
      let totalPrice = 0;
      this.chapterList.forEach((chapter) => {
        if (!(chapter.is_unlock || chapter.is_vipunlock)) {
          totalPrice += chapter.price;
          ids.push(chapter.id);
        }
      });
      this.priceInfo = {
        novelId: this.id,
        chapterId: item.id,
        unlockChapters: ids,
        single: item.price,
        total: totalPrice,
        title: item.title,
      };
      this.unlockPopupVisible = true;
    },
    unlockSuccess() {
      this.getChapterList(this.id);
    },
    goRecommend(id) {
      if (String(id) === String(this.id)) return;
      this.$router.push(`/novel/detail/${id}`);
    },
    readNow() {
      if (this.activeId === '') return;
      this.$router.push(`/novel/${this.id}/chapter/${this.activeId}`);
    },
  },
};
</script>

<style lang="less" scoped>
.novel-detail {
  min-height: 100vh;
  padding-top: 220px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-bottom: 68px;
  &-wrap {
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    padding: 16px 0 0 0;
    min-height: calc(100vh - 220px);
    .novel-title {
      line-height: 36px;
      font-size: @fontMedium;
      font: @black;
      padding-left: 16px;
    }
    .author-info {
      padding-left: 16px;
      display: flex;
      align-items: center;
      height: 40px;
      .author-avatar {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
      .author-name {
        font-size: @fontSmall;
        font: @gray;
      }
    }
    .novel-tags {
      padding: 16px 0 8px 16px;
      /deep/ .novel-tag {
        margin-right: 4px;
        margin-bottom: 8px;
      }
    }
    .novel-chapter {
      overflow-x: scroll;
      padding: 16px 0 0 16px;
      &-scroll {
        display: inline-flex;
        flex-wrap: nowrap;
        min-width: 100%;
        .novel-chapter-item {
          width: max-content;
          -webkit-width: max-content;
          height: 50px;
          padding: 0 10px;
          margin-right: 12px;
          border-radius: 12px;
          line-height: 50px;
          display: flex;
          align-items: center;
          color: @black;
          font-size: @fontLarge;
          background-color: rgba(247, 247, 247, 1);
          &.active {
            color: @theme;
            border: 1px solid @theme;
          }

          .icon {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .recommend-list {
      padding-top: 16px;
      padding-left: 16px;
      display: flex;
      // flex-direction: column;
      flex-wrap: wrap;
      justify-content: space-around;
      .recommend-item {
        width: 156px;
        margin-bottom: 16px;
        .image-wrap {
          height: 200px;
          border-radius: 12px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 12px;
            vertical-align: middle;
          }
        }
        .recommend-info {
          padding-top: 8px;
          min-height: 48px;
          background-color: #fff;
          .novel-title {
            line-height: 24px;
            font-size: @fontLarge;
            color: @black;
            .overflow-ellipsis(1);
          }
          .novel-intro {
            line-height: 16px;
            font-size: @fontSmall;
            color: @gray;
            .overflow-ellipsis(1);
          }
        }
      }
    }
  }

  .novel-operation {
    background-color: #fff;
    position: fixed !important;
    left: 0;
    right: 0;
    bottom: 0;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .border-1px('top', rgba(0, 0, 0, 0.08));
    .operation-button {
      width: 160px;
      height: 44px;
      border-radius: 22px;
      background-color: rgba(13, 13, 13, 0.06);
      display: flex;
      align-items: center;
      justify-content: center;
      color: @black;
      font-size: @fontMedium;
      .op-icon {
        .iconMixin({
          margin-right: 8px;
        });
      }

      &.favorite {
        .op-icon.on {
          background-image: url('~@/assets/images/icon/favorite-on.png');
        }
        .op-icon.off {
          background-image: url('~@/assets/images/icon/favorite-off.png');
        }
      }
      &.read-now {
        background-color: @theme;
        color: #fff;
        .op-icon {
          background-image: url('~@/assets/images/icon/read.png');
        }
      }
    }
  }
}

</style>
